import React, { useEffect } from 'react';

import Categorias from '../../components/Categorias/Categorias';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategoriasRequest } from '../../actions';
import useQuery from '../../utils/hooks/useQuery';

const CategoriasContainer = () => {
  const query = useQuery();
  const dispatch = useDispatch();
  const { categorias } = useSelector(state => ({
    categorias: state?.categoria,
  }));
  const { ready } = categorias;
  useEffect(() => {
    if (!ready) {
      dispatch(fetchCategoriasRequest(query.get('marca')));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, ready]);


  return <Categorias categorias={categorias} />;
};

export default CategoriasContainer;
